
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-rv-bookings/cultural-events",
      function () {
        return require("private-next-pages/group-rv-bookings/cultural-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group-rv-bookings/cultural-events"])
      });
    }
  